export default function Time(userService) {
    'ngInject';

        return function(input) {

            const defaultFormat = 'HH:mm';

            const regionalSettings = userService.getRegionalSettings();

            if (regionalSettings.timeFormat !== defaultFormat
                && (input.indexOf('am') > -1 || input.indexOf('pm') > -1)) {
                return input;
            }

            return moment(input, defaultFormat).format(regionalSettings.timeFormat);
        };
}



// WEBPACK FOOTER //
// ./src/app/filters/time.filter.js